import applogger from '@applogger'
import asArray from '../utils/asArray'

const parseBoolean = function(v) {
  if (typeof v === 'string' && ['true', 'on', 'yes'].includes(v.toLowerCase())) {
    return true
  }
  else if (typeof v === 'string' && v !== '' && v !== '0') {
    return true
  }
  else if (typeof v === 'number' && !isNaN(parseInt(v)) && parseInt(v) !== 0) {
    return true
  }
  else if (typeof v === 'boolean') {
    return v
  }
  return false
}

export default function baseProductFieldMapFactory(taxonomyMap) {
  const mapTaxonomyToValue = (value, field) => {
    try {
      return taxonomyMap[field].filter(item => item.name === value)[0].description
    }
    catch (err) {
      return 'unknown'
    }
  }

  return {
    gst_free: function() { return this.productsettings.taxfree ? '1' : '0' },
    id: function() { return this.id },
    nid: function() { return this.id },
    title: function() { return this.title },
    status: function() { return this.status },
    abstract: function() { return this.abstract },
    description: function() { return this.body },
    award: function() { return (this.award_winner ? 'award_winner' : 'no') },
    product_settings: function() { return this.productsettings },
    dateChanged: function() { return this.modified },
    allow_in_cart: function() {
      if (typeof this.productsettings.allowincart === 'boolean') {
        return this.productsettings.allowincart
      }
      return parseBoolean(this.productsettings.allowincart)
    },
    image: function() {
      if (Array.isArray(this.images) && this.images.length) {
        return this.images[0].image
      }
      else if (Object.prototype.hasOwnProperty.call(this.images, 'image')) {
        return this.images.image
      }
      return null
    },
    varietal: function() {
      if (Array.isArray(this.varietal) && this.varietal.length > 0) return asArray(this, 'varietal').map(item => mapTaxonomyToValue(item, 'varietal'))
      else if (!Array.isArray(this.varietal)) return mapTaxonomyToValue(this.varietal, 'varietal')
      else return ['Other Varietals']
    },
    wine_type: function() {
      if (Array.isArray(this.wine_type) && this.wine_type.length > 0) return asArray(this, 'wine_type').map(item => mapTaxonomyToValue(item, 'wine_type'))[0]
      else if (!Array.isArray(this.wine_type)) return mapTaxonomyToValue(this.wine_type, 'wine_type')
      else return 'Other Wine Type'
    },
    stock: function() {
      return this.productsettings.stock
    },
    stock_string: function() {
      if (this.productsettings.managestock) {
        if (parseInt(this.productsettings.stock) > 0) return 'in-stock'
        else return 'out-of-stock'
      }
      else return 'in-stock'
    },
    ptype: function() {
      const map = {
        shippable: 'tangible',
        nonshippable: 'generic',
        event: 'event_ec_product'
      }
      return map[this.producttype]
    },
    wineproductrrp: function() {
      try {
        let val = parseFloat(this.wineproductrrp)
        if (val <= 0) {
          return this.productsettings.price
        }
        return val
      }
      catch (err) {
        return this.productsettings.price
      }
    },
    price: function() {
      // if (typeof this.productsettings.unit_price === 'string') {
      //   applogger.error(`Product Unit Price for Item: ${this.id}  detected as String ${this.productsettings.unit_price}`)
      // }
      // if (typeof this.productsettings.price === 'string') {
      //   applogger.error(`Product Price for Item: ${this.id}  detected as String ${this.productsettings.unit_price}`)
      // }
      return this.productsettings.price
      // return this.productsettings.unit_price || this.productsettings.price
    },
    cart_base_price: function() {
      return this.productsettings.price
      // return this.productsettings.unit_price || this.productsettings.price
    },
    // Added priceDiscounted back in as it is a sort field in the website.
    priceDiscounted: function(store, fieldMapper) {
      const price = (this.productsettings.unit_price || this.productsettings.price)
      const ptype = fieldMapper.ptype.call(this)
      const item = {
        ...this,
        price,
        ptype,
        taxonomy: fieldMapper.discountGroup.call(this),
        type: this.type
      }

      return price + store.getters['ecommerce/getTotalPriceAdjustment'](item)
    },
    sticky: function() {
      return parseInt(this.featured) || 0
    },
    node_type: function() {
      return this.type
    },
    discountGroup: function() {
      if (this.productsettings.discountgroup) {
        return {
          [this.productsettings.discountgroup.replace(/_(\d+)/, '$1')]: mapTaxonomyToValue(this.productsettings.discountgroup, 'discount_group')
        }
      }
      return {}
    },
    path: function() {
      if (this.seo && this.seo.path) {
        return '/' + this.seo.path
      }

      return ''
    },
    imagesGallery: function() {
      if (Array.isArray(this.images) && this.images.length) {
        return this.images.reduce((acc, image) => [...acc, image.image], []).filter(x => x)
      }
      else if (Object.prototype.hasOwnProperty.call(this.images, 'image')) {
        return this.images.image
      }
      return []
    }
  }
}
